import { render, staticRenderFns } from "./subjectCenter.vue?vue&type=template&id=0927ccae&scoped=true"
import script from "./subjectCenter.vue?vue&type=script&lang=js"
export * from "./subjectCenter.vue?vue&type=script&lang=js"
import style0 from "./subjectCenter.vue?vue&type=style&index=0&id=0927ccae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0927ccae",
  null
  
)

export default component.exports